import { GET_DYNAMIC_LIST_TITLE_SUCCESS } from '../constants';

export default function dynamicListTitles(state = {}, action) {
    switch (action.type) {
        case GET_DYNAMIC_LIST_TITLE_SUCCESS:
            return {
                ...state,
                data: {
                    dynamicListTitle: action.payload.dynamicListTitle,
                    dynamicListDescription: action.payload.dynamicListDescription,
                    dynamicCancellationData: action.payload.dynamicCancellationData
                }
            };
        default:
            return state;
    }
}